module.exports = __webpack_public_path__ + "img/warning.0ede4377.svg";